module.exports = __webpack_public_path__ + "static/media/background-space.8699e94d.png";